//LIBRARY
import styled from "styled-components";
//MISC
import {
  COLORS,
  BORDER_RADIUS,
  SIZE,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_WEIGHT,
  DEVICE_TYPE,
  MARGIN,
} from "constants/variables";
import cursorIcon from "assets/img/Cursor.png";

export const BigContainer = styled.div`
  display: flex;
  gap: ${SIZE.max28};

  flex-direction: column;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    gap: ${MARGIN.max12};
  }
`;
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
  gap: ${MARGIN.fix24};
  margin-top: 24px;
  @media (min-width: 1024px) and (max-width: 1605px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    grid-template-columns: 1fr;
    gap: ${MARGIN.max12};
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  gap: ${MARGIN.fix24};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    gap: ${MARGIN.max12};
  }
`;

export const ColumnOne = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  gap: ${MARGIN.fix24};
  width: 100%;

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    gap: ${MARGIN.max12};
  }
`;
export const Card = styled.div`
  position: relative;
  background: ${COLORS.VividAuburn};
  border-radius: ${BORDER_RADIUS.radius24};
  padding: 40px;
  overflow: hidden;
  width: 100%;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding: ${MARGIN.max56} ${MARGIN.max40} ${MARGIN.max56} ${MARGIN.max40};
  }
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    border-radius: ${BORDER_RADIUS.radius16};
  }
`;

export const MediumCard = styled(Card)`
  width: 100%;
  height: 100%;
  max-height: 140px;
  display: flex;
  flex-direction: row;
  background-color: transparent;
  padding: 0px;
  gap: 24px;
  @media (max-width: 1024px) {
    gap: 12px;
    min-height: 100px;
    height: auto;
    max-height: none;
  }
`;

export const FirstCard = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: auto;
  max-width: 338px;
  padding: 64px;

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    height: 225px;
    width: 100%;
    max-width: none;
    padding: 40px 50px;
  }
`;
export const ThirdCard = styled(Card)`
  padding: ${MARGIN.max40} ${MARGIN.max48} ${MARGIN.max50} ${MARGIN.max48};
  display: flex;
  flex-direction: column;
  height: auto;
  width: 100%;
  @media (min-width: 1024px) and (max-width: 1605px) {
    width: 100%;
    flex: 1;
  }

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    padding: ${MARGIN.max40} ${MARGIN.max40} ${MARGIN.max50} ${MARGIN.max40};
  }
`;

export const Row = styled.div`
  display: flex;
  height: 100%;

  gap: ${MARGIN.fix24};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    flex-direction: column;
    gap: ${MARGIN.max12};
  }
`;

export const TitleLarge = styled.div`
  margin-bottom: ${MARGIN.max28};
`;

export const TitleMedium = styled.h2`
  margin-bottom: ${({ isSocialMediaCard }) =>
    isSocialMediaCard ? MARGIN.max28 : MARGIN.fix32};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    margin-bottom: ${MARGIN.max12};
  }
`;

export const IconTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-direction: column;
`;

export const Icon = styled.img`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 84px;
  height: auto;
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-right: 10px;
  }
`;

export const MiddleCard = styled(Card)`
  width: 100%;
  height: 100%;
  background-color: ${COLORS.FaluRed};
  padding: ${MARGIN.max56} ${MARGIN.max48};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    padding: ${MARGIN.fix32} ${MARGIN.max40};
  }
`;

export const SecondCard = styled(Card)`
  width: 100%;

  @media (max-width: 1024px) {
    width: auto;
    max-height: auto;
    height: auto;
  }
`;
export const FourthCard = styled(Card)<{ biggerCursor?: boolean }>`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${COLORS.FaluRed};
  justify-content: space-between;
  padding: 0 ${SIZE.max55};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    justify-content: center;
    order: 3;
    max-height: none;
    padding: 0 ${MARGIN.max28};
  }
  min-height: 150px;
  width: 100%;
`;

export const Title = styled.h2`
  color: ${COLORS.Cultured};
  font-size: ${FONT_SIZE.max32};
  font-family: ${FONT_FAMILY.poppins};
  font-weight: ${FONT_WEIGHT.semiBold};
  white-space: nowrap;
`;

export const SocialIcon = styled.img<{ biggerCursor?: boolean }>`
  height: 32px;
`;
export const SiglaIcon = styled.img<{ biggerCursor?: boolean }>`
  height: 75%;
  border-radius: ${BORDER_RADIUS.radius16};
`;

export const ContactStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.max12};
`;

export const LinkWrapperFirstCard = styled.div`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;
  text-align: center;
  height: 100%;
  gap: 16px;
  @media (max-width: 500px) {
    max-width: 200px;
  }
`;
export const LinkWrapper = styled.a`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  text-decoration: none;
  color: inherit;
`;

export const StyledLink = styled.a`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  text-decoration: none;
  color: inherit;
`;

export const WrapperRoundedCircle = styled.div`
  width: 100%;
  height: 0px;
  position: relative;
`;
export const RoundedCircle = styled.img`
  position: absolute;
  top: -50px;
  right: -50px;
  width: 200px;
  @media (max-width: 1200px) {
    width: 140px;
    top: -60px;
  }
  @media (max-width: 1024px) {
    width: 140px;
    top: -60px;
  }
`;

export const ColumnSecondCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 180px;
  gap: 10px;
`;

export const RowSecondCard = styled.div`
  display: flex;
  flex-direction: row;
  gap: 60px;
  @media (max-width: 1740px) {
    gap: 40px;
    max-width: 500px;
  }

  @media (max-width: ${DEVICE_TYPE.mobile}) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const RowThirdCard = styled.div`
  display: flex;
  flex-direction: row;
  gap: 60px;

  @media (max-width: ${DEVICE_TYPE.mobile}) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const CookiesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 39px;
  gap: 40px;
  cursor: pointer;
  @media (max-width: 1024px) {
    margin-top: 0;
    gap: none;
  }
`;

export const HorizontalLine = styled.hr`
  width: 79%;
  height: 2px;
  background-color: ${COLORS.lineColor};
  margin-top: 10px;
  border: none;
  cursor: default;
  @media (max-width: 1900px) {
    width: 76%;
  }
  @media (max-width: 1700px) {
    width: 71%;
  }

  @media (max-width: 1024px) {
    width: 100%;
    margin-top: 24px;
    margin-bottom: 16px;
  }
`;

export const HorizontalLineThird = styled(HorizontalLine)`
  width: 63%;
  @media (max-width: 1900px) {
    width: 60%;
  }
  @media (max-width: 1700px) {
    width: 55%;
  }
`;

export const ColumnThirdCard = styled(ColumnSecondCard)`
  max-width: 400px;
`;

export const IconCard = styled.div`
  flex: 1;
  max-width: calc(50% - 16px);
  height: 140px;
  border-radius: ${BORDER_RADIUS.radius32};
  background-color: ${COLORS.FaluRed};
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    width: calc(33.33% - 16px);
    height: 100px;
    max-width: none;
    flex: 1;
    border-radius: ${BORDER_RADIUS.radius16};
  }
`;
export const SocialCard = styled.div``;

export const DsuWrapper = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export const SocialWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  padding-top: ${SIZE.max32};
  gap: ${SIZE.max60};
`;
